import { MediaFileConnectionType } from "@next-platform/packages-ts-types";
import { MediaFileKind } from "../types/types";
// An avatar names the entity it is the avatar of; every other kind names the chatbot.
const KIND_CONNECTION_TYPES = {
    [MediaFileKind.PERSONA_AVATAR]: MediaFileConnectionType.PERSONA,
    [MediaFileKind.USER_AVATAR]: MediaFileConnectionType.USER,
};
/**
 * The one entity a surface with room for a single link shows: the persona or profile a persona or user avatar
 * belongs to, otherwise the chatbot. Falls back to the chatbot when the avatar's owner could not be named.
 */
export default function getMediaFileRelatedEntity({ kind, primaryCharacter, connections, }) {
    const connectionType = KIND_CONNECTION_TYPES[kind];
    const kindConnection = connectionType ? connections.find((connection) => connection.type === connectionType) : undefined;
    return kindConnection ?? primaryCharacter;
}
